/// <reference types="../commons.d.ts" preserve="true" />
/* eslint-disable prefer-destructuring */
/**
 * This module provides various functions to animate elements.
 *
 * {@include ../lib/animation/README.md}
 *
 * @category Core Modules
 * @module animation
 * @packageDocumentation
 */
import { o_util } from "@gr-common/common/namespaces";
import type { GlobalUtils } from "./index.js";

export type { Easings, EasingFunc } from "../lib/animation/head.js";

/**
 * Animation namespace provides various animation utilities
 */
export type Animation = GlobalUtils["animation"];

/**
 * Animation namespace provides various animation utilities
 */
export const animation: Animation = o_util?.animation ?? {};

/** Export reference for {@link Animation.easings} */
export const easings: Animation["easings"] = animation.easings;
/** Export reference for {@link Animation.fadeIn} */
export const fadeIn: Animation["fadeIn"] = animation.fadeIn;
/** Export reference for {@link Animation.fadeOut} */
export const fadeOut: Animation["fadeOut"] = animation.fadeOut;
/** Export reference for {@link Animation.scrollTo} */
export const scrollTo: Animation["scrollTo"] = animation.scrollTo;
/** Export reference for {@link Animation.transition} */
export const transition: Animation["transition"] = animation.transition;
/** Export reference for {@link Animation.transitions} */
export const transitions: Animation["transitions"] = animation.transitions;
